import { render, staticRenderFns } from "./SpeedChart.vue?vue&type=template&id=642e41d0&scoped=true&"
import script from "./SpeedChart.vue?vue&type=script&lang=js&"
export * from "./SpeedChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642e41d0",
  null
  
)

export default component.exports